import PropTypes from 'prop-types';
import { useState } from 'react';
import MerchandiseServicesModal from '../merchandiseServicesModal/merchandiseServicesModal';

export default function ContractDetailsTable({ data, services, isCancelledContract }) {
  const [isOpen, setIsOpen] = useState(false);
  const istoggle = () => {
    if (!isCancelledContract) setIsOpen(!isOpen);
  };
  return (
    <table className="contract-details">
      <tbody>
        {data.map((row) => {
          let ViewTD = null;
          if (row.value === 'VIEW') {
            ViewTD = (
              <td className="value view-scroll" onClick={istoggle}>
                {row.value}
              </td>
            );
          }
          return (
            <tr key={row.id}>
              <td>{row.id}</td>
              <td className="key">{row.key}</td>
              {!ViewTD ? <td className="value">{row.value}</td> : ViewTD}
            </tr>
          );
        })}
      </tbody>
      <MerchandiseServicesModal
        isViewOpen={isOpen}
        isViewToggle={istoggle}
        merchandiseServicesList={services}
      />
    </table>
  );
}

ContractDetailsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  services: PropTypes.shape({}),
  isCancelledContract: PropTypes.bool,
};
